import { getCurrentLanguage } from 'globalutils/commonUtils';

export const downloadFile = async (url, fileName) => {
  try {
    const response = await fetch(url, {
      headers: {
        'Accept-Language': getCurrentLanguage(),
      },
    });

    if (response.ok) {
      const blob = await response.blob();
      const fileUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = fileUrl;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(fileUrl);
    } else {
      console.error(`Error downloading file: ${response.status}`);
    }
  } catch (error) {
    console.error('Failed to export file:', error);
  }
};
